// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"686":"e95e589e","704":"66a1bf70","877":"24f52fdf"}[chunkId] + ".chunk.css";
};